import { uniqueId } from 'lodash';
import { ProjectTimeEntry } from '../../../../Projects/types';
import { TimeEntryData } from './types';
import { UNIQUE_ID_PREFFIX, minToHoursInput } from './utils';

export function mapToFormData({
  id,
  projectId,
  costCenterId,
  notes,
  minutes,
  extraFields,
  recordTypeName,
  timeEntryId,
  timeEntryChangeRequestId,
}: ProjectTimeEntry): TimeEntryData {
  return {
    id: id,
    projectId,
    costCenterId,
    notes: notes || '',
    hours: minutes ? minToHoursInput(minutes) : null,
    extraFields,
    recordTypeName,
    timeEntryId,
    timeEntryChangeRequestId,
  };
}

export function mapToProjectTimeEntry({
  id,
  projectId,
  costCenterId,
  notes,
  hours,
  extraFields,
  recordTypeName,
  timeEntryId,
  timeEntryChangeRequestId,
}: TimeEntryData): ProjectTimeEntry | null {
  if (!hours || !projectId) {
    return null;
  }

  return {
    id,
    projectId: projectId ?? null,
    costCenterId: costCenterId ?? null,
    minutes: Math.round(hours * 60),
    notes: notes && notes.trim() ? notes.trim() : null,
    extraFields: extraFields ?? [],
    timeEntryId: timeEntryId ?? null,
    timeEntryChangeRequestId: timeEntryChangeRequestId ?? null,
    recordTypeName: recordTypeName ?? null,
  };
}

export function createEmptyItem(
  projectId: string | null,
  defaultRecordTypeName: string | null,
  initialHours?: number,
  timeEntryId?: string | null,
): TimeEntryData {
  return {
    id: uniqueId(`${UNIQUE_ID_PREFFIX}_${Date.now()}`),
    timeEntryId: timeEntryId ?? null,
    timeEntryChangeRequestId: null,
    notes: '',
    hours: initialHours ?? 1,
    projectId,
    costCenterId: null,
    extraFields: [],
    recordTypeName: defaultRecordTypeName,
  };
}
